const internalProductStatuses = ['NEW', 'In Process', 'Revised', 'Ready for Review', 'Approved', 'Broken', '*IGNORE DEV/TEST*'];
export default internalProductStatuses;